'use client';

import { startTransition } from 'react';
import { useShallow } from 'zustand/shallow';
import { usePageAction } from '@repo/hooks/usePageAction';
import { useFormActionViewedContext } from '@repo/segment/Analytics/FormActionViewed';
import { APY_INPUT_PATTERN } from '../../constants';
import { ApyPercentCalculatorInput } from '../../shared/ApyPercentCalculatorInput';
import { formatToDisplayValue, isAmbiguousAnnualApyString } from '../../utils/calculatorFormMath';
import { handleAnnualApyInput } from './annualApyInput';
import { useCdCalculatorStore } from './calculatorStore';

export function AnnualPercentYieldForm() {
  // TODO: Segment Standardization Cleanup
  const fireCdCalculatorInteractedPageAction = usePageAction({
    actionName: 'cd_calculator_interacted',
    actionSection: 'banking',
    actionType: 'select',
  });
  const { fireFieldInteracted: contextFireFieldInteracted } = useFormActionViewedContext();
  const {
    annualPercentageYield,
    annualPercentageYieldError,
    initialDeposit,
    setField,
    termLength,
    termLengthUnit,
  } = useCdCalculatorStore(
    useShallow(state => ({
      annualPercentageYield: state.formFields.annualPercentageYield,
      annualPercentageYieldError: state.errors.annualPercentageYield,
      initialDeposit: state.formFields.initialDeposit.includes(',')
        ? state.formFields.initialDeposit.replace(/,/g, '')
        : formatToDisplayValue(state.formFields.initialDeposit),
      setField: state.setField,
      termLength: state.formFields.termLength,
      termLengthUnit: state.formFields.termLengthUnit,
    })),
  );

  const fireFieldInteracted = (value: string) => {
    contextFireFieldInteracted({
      field: 'annual_percentage_yield_value_input',
      fieldType: 'text',
      fieldValue: value,
      additionalAttributes: {
        annual_percentage_yield_value_input: value,
        initial_deposit_value_input: initialDeposit,
        term_length_value_input: termLength,
        term_length_unit_value_input: termLengthUnit,
        page_type: 'roundup',
      },
    });
  };

  return (
    <ApyPercentCalculatorInput
      error={annualPercentageYieldError}
      id="annual-percentage-yield"
      value={annualPercentageYield}
      onChange={e => {
        handleAnnualApyInput(e.target.value, {
          fireCdCalculatorInteractedPageAction,
          fireFieldInteracted,
          initialDeposit,
          termLength,
          termLengthUnit,
          setField,
          startTransition,
        });
      }}
      onBlur={e => {
        const target = e.target.value;
        if (!APY_INPUT_PATTERN.test(target)) {
          return;
        }
        if (isAmbiguousAnnualApyString(target)) {
          handleAnnualApyInput(target.replace('.', ''), {
            fireCdCalculatorInteractedPageAction,
            fireFieldInteracted,
            initialDeposit,
            termLength,
            termLengthUnit,
            setField,
            startTransition,
          });
        }
      }}
    />
  );
}
